import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import ScrollReactTable from 'components/shared/ScrollReactTable/ScrollReactTable';
import { alarmSeverityToIcon, capitalizeFirstLetter, nSort } from 'common/utils/helpers';
import SvgAF, { IconAndText } from 'components/shared/SvgAF/SvgAF';
import { IconLoader } from 'common/IconLoader';
import moment from 'moment';
import './AlarmTable.css';

export const AlarmTableRow = (props) => {
  return <div className="rt-tr">{props.children}</div>;
};

const AlarmTable = (props) => {
  const localAlarms = useSelector((store) =>
    store.data.alarms && store.data.alarms.deviceAlarms && store.data.alarms.deviceAlarms[props.deviceID] != null
      ? store.data.alarms.deviceAlarms[props.deviceID]
      : []
  );

  const isFetching = useSelector((store) => store.data.alarms == null);
  let pageSize = 10;

  if (localAlarms && localAlarms.length > pageSize) {
    pageSize = localAlarms.length;
  }

  let overlay = null;

  // if (localAlarms.length === 0 && !isFetching) {
  //   overlay = <div className={'Gobal_Table_NonErrorOverlay'}>No current alarms</div>;
  // }

  let sortedAlarms = nSort(localAlarms, [
    { metric: 'severity', order: 'd' },
    { metric: 'start', order: 'a' }
  ]);

  const getCols = () => {
    let defaultCols = [
      {
        Header: (row) => (
          <div className="Alarm_Table_HeaderDiv Alarm_Table_HeaderDiv_Time" data-tip="Time">
            <IconAndText
              img={IconLoader.icon_table_sort}
              hoverImg={IconLoader.icon_table_sort_hover}
              text={'Time'}
              reverse
            />
          </div>
        ),
        className: 'Alarm_Table_TimeColumn',
        sortable: true,
        accessor: 'start',
        Cell: (row) => <div className="">{moment(row.value).format('MMM DD, YYYY h:mm a')}</div>
      },
      {
        Header: (row) => (
          <div className="Alarm_Table_HeaderDiv Alarm_Table_HeaderDiv_Center" data-tip="Level">
            <IconAndText
              img={IconLoader.icon_table_sort}
              hoverImg={IconLoader.icon_table_sort_hover}
              text={'Level'}
              reverse
            />
          </div>
        ),
        className: 'Alarm_Table_LevelRow',
        accessor: 'severity',
        width: 92,
        Cell: (row) => {
          let content = row.value.toLowerCase();
          content = <SvgAF img={alarmSeverityToIcon(row.value)} tooltip={capitalizeFirstLetter(row.value)} />;
          return <div className="Global_Table_CellDiv AlarmTable_IconDiv">{content}</div>;
        }
      },
      {
        Header: (row) => (
          <div className="Alarm_Table_HeaderDiv" data-tip="Name">
            <IconAndText
              img={IconLoader.icon_table_sort}
              hoverImg={IconLoader.icon_table_sort_hover}
              text={'Name'}
              reverse
            />
          </div>
        ),
        className: 'Alarm_Table_NameColumn',
        accessor: 'name',
        Cell: (row) => {
          return (
            <div className="Alarm_Table_NameDiv">
              <div className="Alarm_Table_NameInnerDiv">{row.value}</div>
              <div className="Alarm_Table_InfoDiv">
                <SvgAF
                  img={IconLoader.icon_info}
                  hover={IconLoader.icon_info_hover}
                  tooltip={`${row.value}${row.original.description ? '<br/>' + row.original.description : ''}`}
                  tooltipMultiline={true}
                />
              </div>
            </div>
          );
        }
      }
    ];

    if (props.isGa2) {
      const serviceImpactCol = {
        Header: (row) => (
          <div className="Alarm_Table_HeaderDiv Alarm_Table_HeaderDiv_Center" data-tip="Service Impact">
            <IconAndText
              img={IconLoader.icon_table_sort}
              hoverImg={IconLoader.icon_table_sort_hover}
              text={'Service Impact'}
              reverse
            />
          </div>
        ),
        className: 'Alarm_Table_ServiceImpactRow',
        accessor: 'serviceImpact',
        Cell: (row) => {
          return (
            <div className="AlarmTable_CellWrapper" data-tip={row.value ?? 'N/A'}>
              {row.value ?? 'N/A'}
            </div>
          );
        }
      };
      const sourceCol = {
        Header: (row) => (
          <div className="Alarm_Table_HeaderDiv Alarm_Table_HeaderDiv_Center" data-tip="Source">
            <IconAndText
              img={IconLoader.icon_table_sort}
              hoverImg={IconLoader.icon_table_sort_hover}
              text={'Source'}
              reverse
            />
          </div>
        ),
        className: 'Alarm_Table_SourceRow',
        accessor: 'source',
        width: 105,
        Cell: (row) => {
          return (
            <div className="AlarmTable_CellWrapper" data-tip={row.value ?? 'N/A'}>
              {row.value ?? 'N/A'}
            </div>
          );
        }
      };
      defaultCols = [...defaultCols.slice(0, 2), serviceImpactCol, sourceCol, ...defaultCols.slice(2)];
    }

    return defaultCols;
  };

  return (
    <div className="AlarmTable_Div">
      <ScrollReactTable
        showPagination={false}
        noDataText={''}
        className={'Global_Table AlarmTable'}
        resizable={false}
        sortable={true}
        minRows={10}
        pageSize={20}
        data={sortedAlarms}
        overlay={overlay}
        fetching={isFetching}
        columns={getCols()}
        TrComponent={(props) => <AlarmTableRow {...props} />}
      />
    </div>
  );
};

export default memo(AlarmTable);
